import React from 'react'
import Layout from '../../Layout.jsx';
import '../../CustomAssets/Css/Pages/SubPages/TermsConditionsPrivacyPolicy.css';

export default function PrivacyPolicy() {
  return (
    <>
      <Layout>

        <section className="banner org_clr">
          <div className="container ">
            <div className="row gy-4 gy-sm-0 align-items-center justifyCenter">
              <div className="col-12  col-sm-12">
                <div className="banner__content">
                  <h1 className="banner__title display-4 wow fadeInLeft textCenter" data-wow-duration="0.8s">Privacy Policy</h1>
                </div>
              </div>
            </div>
          </div>
        </section>

        <div className="tp-page-area sec-mar">
          <div className="container-fluid custom-container">
            <div className="row">
              <div className="col-xl-12">
                <div className="tp-page-content">
                  <div className="tp-page-post">
                    <div data-elementor-type="wp-page" data-elementor-id="47" className="elementor elementor-47">

                      <div className="elementor-element elementor-element-3183344" data-id="3183344"
                        data-element_type="container">
                        <div className="elementor-element elementor-element-ebda982 elementor-widget elementor-widget-tp-choose"
                          data-id="ebda982" data-element_type="widget" data-widget_type="tp-choose.default">
                          <div className="elementor-widget-container">


                            <section className="choose-us ">

                              <div className="container">
                                <div className="row gy-5 gy-lg-0 justify-content-between align-items-center section">
                                  <div className="col-12 col-lg-12 col-xxl-12">
                                    <div className="section__content ms-lg-4 ms-xl-0">

                                      <div className='tmndcm'>
                                        <h2 className="title section__content-title wow fadeInUp" data-wow-duration="0.8s">Privacy Policy</h2>

                                        <div className="section__content-inner wow fadeInUp" data-wow-duration="0.8s">
                                          <p>At LOANSMONEY, your privacy is our top priority. We are committed to protecting the confidentiality and security of your personal information while delivering a transparent and trustworthy experience across all our platforms. This Privacy Policy explains how we collect, use, and safeguard your data when you engage with our services.
                                            <br />
                                            This document is created in accordance with the Information Technology Act, 2000 and applicable Indian law. It is digitally maintained and does not require physical signatures.</p>
                                        </div>
                                      </div>


                                      <div className='tmndcm'>
                                        <h2 className="title section__content-title wow fadeInUp" data-wow-duration="0.8s">Internal Compliance & Policy Declaration</h2>

                                        <div className="section__content-inner wow fadeInUp" data-wow-duration="0.8s">
                                          <p>This privacy and terms policy aligns with the IT (Intermediaries Guidelines) Rules, 2011 and all relevant Indian cybersecurity regulations. The website www.loansmoney.in is fully owned and operated by LOANSMONEY PRIVATE LIMITED, a company incorporated under the Companies Act, 2013, headquartered at SATASHI PAUL PARA, G. I. P. COLONY, HOWRAH, G. I. P. COLONY, BALLY, JAGACHHA, HOWRAH 711112, WEST BENGAL.
                                            <br />
                                            All references to the company herein apply to its employees, directors, representatives, and legal assigns.</p>
                                        </div>
                                      </div>

                                      <div className='tmndcm'>
                                        <h2 className="title section__content-title wow fadeInUp" data-wow-duration="0.8s">Further Terms</h2>

                                        <div className="section__content-inner wow fadeInUp" data-wow-duration="0.8s">
                                          <p>By accessing or using any services provided by LOANSMONEY PRIVATE LIMITED, you agree to abide by all terms, conditions, and policies set forth herein. The use of this platform is intended solely for individuals seeking financial products and services through our partnered Banks and NBFCs. All services are subject to eligibility, verification, and approval by the respective financial institutions.
                                            <br />
                                            Users must provide accurate, current, and complete information. LOANSMONEY reserves the right to suspend or terminate access if any information provided is found to be false or misleading. The company disclaims any liability arising from third-party decisions, as we do not interfere with the independent policies of Banks or NBFCs regarding loan approvals or rejections.
                                            <br />
                                            All digital content, logos, and branding displayed on this platform are the intellectual property of LOANSMONEY and cannot be reused or reproduced without written consent.
                                            <br />
                                            Any disputes arising from the use of this website shall be governed by Indian laws and fall under the jurisdiction of competent courts located in India.
                                            <br />
                                            By continuing to use this site, you confirm that you have read, understood, and agreed to the terms outlined in this document, including the Privacy Policy, Disclaimer, and any additional guidelines issued from time to time.</p>
                                        </div>
                                      </div>


                                    </div>
                                  </div>
                                </div>
                              </div>
                            </section>


                          </div>
                        </div>
                      </div>




                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

      </Layout>

    </>
  )
}
